import React, { Component } from 'react';
import ContraLogo from './Graphics/contraline_logo.png';
import './App.css';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Paper from 'material-ui/Paper';
import InterestForm from './components/InterestForm';
import TrialForm from './components/TrialForm';
import { Next, Submit } from './components/SubmitAndCheckbox';
import ThankYou from './components/ThankYou';
import * as firebase from 'firebase';
import axios from 'axios';


// Initialize Firebase
import { Config, apiKey, cityKey } from './config.js';
firebase.initializeApp(Config);
const database = firebase.database();
const state_lookup = {
  AL: '01',
  AK: '02',
  AZ: '04',
  AR: '05',
  CA: '06',
  CO: '08',
  CT: '09',
  DC: '00',
  DE: '10',
  FL: '12',
  GA: '13',
  HI: '15',
  ID: '16',
  IL: '17',
  IN: '18',
  IA: '19',
  KS: '20',
  KY: '21',
  LA: '22',
  ME: '23',
  MD: '24',
  MA: '25',
  MI: '26',
  MN: '27',
  MS: '28',
  MO: '29',
  MT: '30',
  NE: '31',
  NV: '32',
  NH: '33',
  NJ: '34',
  NM: '35',
  NY: '36',
  NC: '37',
  ND: '38',
  OH: '39',
  OK: '40',
  OR: '41',
  PA: '42',
  RI: '44',
  SC: '45',
  SD: '46',
  TN: '47',
  TX: '48',
  UT: '49',
  VT: '50',
  VA: '51',
  WA: '53',
  WV: '54',
  WI: '55',
  WY: '56',
};

const Logo = () =>
  <div style={{ textAlign: "center" }}>
    <a href="https://www.contraline.com" style={{}}>

      <img src={ContraLogo} alt="logo" className="Contralogo" style={{
        height: 30,
        paddingBottom: 60
      }} />
    </a>
  </div>

class App extends Component {
  constructor() {
    super();
    this.state = {
      first_name: '',
      last_name: '',
      email: '',
      interest_adam: false,
      interest_nest: false,
      trial_interest: false,
      year: '',
      gender: '',
      city: '',
      location_state: '',
      submitted: false,
      page: 0,
      id: '',
      cities: [],
    };
  }

  handleStateChange = text => {
    console.log(text);
    if (text == 'DC') {
      this.setCities([], text);
    } else {
      console.log('here');
      this.cityRequest(text, this.setCities);
    }
  };
  setCities = (cities, state) => {
    this.setState({
      ...this.state,
      cities: cities,
      city: '',
      location_state: state,
    });
  };
  handleChange = (field, text) => {
    this.setState({
      ...this.state,
      [field]: text,
    });
  };

  handleNext = () => {
    if (!this.state.submitted) {
      this.setState({ ...this.state, submitted: true });
      var _resolvedPromise = Promise.resolve();
      _resolvedPromise
        .then(() => {
          return this._checkField(this.state.first_name, 'No First Name Field');
        })
        .then(() => {
          return this._checkField(this.state.last_name, 'No Last Name Field');
        })
        .then(() => {
          return this._checkField(this.state.email, 'No Email Field');
        })
        .then(() => {
          return this._checkEmailValid();
        })
        .then(() => {
          return this._checkEmailDB();
        })
        .then(() => {
          return this._addDBSimple();
        })
        .then(id => {
          // this.emailRequest(); // Skip email service call
          this.setState({ ...this.state, id: id, page: 1 });
        })
        .catch(err => {
          this.setState({ ...this.state, submitted: false });
          alert(err);
        });
    }
  };

  handleFormSubmit = () => {
    /*
    *Functions returning promises denoted by _function()
    *promise functions must return resolve and optionally reject. 
    *_resolvedPromise and _resolverPromise2 start promise chain on resolve for readability
    *if any promise return reject("str"), then error_message will automatically be passed down until caught by .catch
    *for example of passing props through promises see _getName and ensuing .then(name => ) statement
    *The primary purpose of this promise chain is so  _checkEmailDB could evaluate in synchronous time. all other functions are 
    *are effectively already synchronous. However, checkEmailValid could be remade to only allow for real emails whcih would
    *likely also be an async function. 
    *_checkEmailDB also receives promise from firebase. if firebase error, seperate reject() called
    *The promise chain also serves to make alert(error) very easy to code and reason about.
    */
    var _resolverPromise2 = Promise.resolve();
    _resolverPromise2
      .then(() => {
        return this._checkField(this.state.year, 'No Birth Year Selected');
      })
      .then(() => {
        return this._checkField(this.state.gender, 'No Gender Selected');
      })
      .then(() => {
        return this._checkField(this.state.state, 'No State Selected');
      })
      .then(() => {
        return this._checkCity(this.state.city, 'No City Selected');
      })
      .then(() => {
        return this._addDBComplex();
      })
      .then(() => {
        this.setState({ ...this.state, submitted: false });
        this.cleanState();
      })
      .catch(err => {
        alert(err);
      });
  };
  _checkField = (field, error) => {
    return new Promise((resolve, reject) => {
      if (field !== '') {
        resolve();
      } else {
        reject(error);
      }
    });
  };
  _checkCity = (field, error) => {
    return new Promise((resolve, reject) => {
      if (this.state.location_state == 'DC') {
        resolve();
      } else {
        if (field !== '') {
          resolve();
        } else {
          reject(error);
        }
      }
    });
  };
  _checkEmailValid = () => {
    return new Promise((resolve, reject) => {
      const x = this.state.email;
      var atpos = x.indexOf('@');
      var dotpos = x.lastIndexOf('.');
      if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= x.length) {
        reject('Not a valid email address');
      } else {
        resolve();
      }
    });
  };
  _checkEmailDB = () => {
    return new Promise((resolve, reject) => {
      // Skip database check since read is not allowed
      console.log('⚠️ Skipping database email check (read not permitted)');
      resolve();
    });
  };
  _addDBSimple = () => {
    return new Promise((resolve, reject) => {
      console.log('Calling Cloud Function to submit data...');
      
      // Call the Cloud Function via HTTP
      const functionUrl = 'https://us-central1-contraportal-2ec72.cloudfunctions.net/checkEmailAndSubmit';
      
      axios.post(functionUrl, {
        data: {
          first_name: this.state.first_name,
          last_name: this.state.last_name,
          email: this.state.email,
          interest_adam: this.state.interest_adam,
          interest_nest: this.state.interest_nest,
          trial_interest: this.state.trial_interest,
          subyear: new Date().getFullYear(),
          month: new Date().getMonth(),
          date: new Date().toDateString(),
        }
      })
      .then((response) => {
        console.log('✅ Successfully submitted via Cloud Function');
        console.log('Response:', response.data);
        if (response.data.result && response.data.result.id) {
          resolve(response.data.result.id);
        } else {
          reject('Unexpected response format from server');
        }
      })
      .catch((error) => {
        console.error('❌ Cloud Function error:', error);
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          if (errorData.error && errorData.error.message) {
            if (errorData.error.message.includes('already registered')) {
              reject('This email address is already registered');
            } else if (errorData.error.message.includes('Invalid email')) {
              reject('Invalid email format');
            } else {
              reject(errorData.error.message);
            }
          } else {
            reject('There was an error submitting your information');
          }
        } else {
          reject('Network error: Could not connect to server');
        }
      });
    });
  };
  _addDBComplex = () => {
    return new Promise((resolve, reject) => {
      if (this.state.id !== '') {
        console.log('Calling Cloud Function to update user details...');
        
        // Call the Cloud Function via HTTP
        const functionUrl = 'https://us-central1-contraportal-2ec72.cloudfunctions.net/updateUserDetails';
        
        axios.post(functionUrl, {
          data: {
            id: this.state.id,
            city: this.state.city,
            state: this.state.location_state,
            year: this.state.year,
            gender: this.state.gender
          }
        })
        .then((response) => {
          console.log('✅ Successfully updated user details');
          console.log('Response:', response.data);
          resolve();
        })
        .catch((error) => {
          console.error('❌ Cloud Function error:', error);
          if (error.response && error.response.data && error.response.data.error) {
            reject(error.response.data.error.message || 'There was an error updating your details');
          } else {
            reject('Network error: Could not connect to server');
          }
        });
      } else {
        reject('There was an error submitting this information.');
      }
    });
  };
  cleanState() {
    this.setState({
      ...this.state,
      first_name: '',
      middle_name: '',
      last_name: '',
      email: '',
      interest_adam: false,
      interest_nest: false,
      trial_interest: false,
      year: '',
      gender: '',
      city: '',
      location_state: '',
      submitted: false,
      page: 3,
    });
  }
  cityRequest(text, callback) {
    let state = state_lookup[text];
    axios
      .get(
        'https://api.census.gov/data/2014/acs?get=NAME,B01001_001E&for=place:*&in=state:' +
        state
      )
      .then(function (response) {
        debugger;
        let cities = [];
        response.data.dataset.map(x => {
          let c = x[0].indexOf(',');
          let city = x[0].substring(0, c);
          let s = city.lastIndexOf(' ');
          city = city.substring(0, s);
          cities.push(city);
        });
        callback(cities, text);
      });
  }
  emailRequest() {
    axios
      .get(
        'http://165.227.66.147?name=' +
        this.state.first_name +
        '%20' +
        this.state.last_name +
        '&email=' +
        this.state.email +
        '&key=' +
        apiKey
      )
      .then(function (response) {
        console.log('email sent');
      });
  }

  handleSkip = () => {
    this.setState({
      ...this.state,
      page: 3,
    });
  };
  render() {
    if (this.state.page == 0) {
      return (
        <MuiThemeProvider>
          <div className="App">
            <Logo />
            <Paper zDepth={2} className="InterestForm">
              <div>
                <InterestForm onChange={this.handleChange} state={this.state} />
                <Next onNext={this.handleNext} />
              </div>
            </Paper>
          </div>

        </MuiThemeProvider>
      );
    } else if (this.state.page == 1) {
      return (
        <MuiThemeProvider>
          <div className="App">
            <Logo />
            <Paper zDepth={2} className="InterestForm">
              <div>
                {' '}
                <TrialForm
                  state={this.state}
                  onStateChange={this.handleStateChange}
                  onChange={this.handleChange}
                />
                {' '}
                <Submit
                  onSubmit={this.handleFormSubmit}
                  onNext={this.handleNext}
                  onSkip={this.handleSkip}
                />
              </div>
            </Paper>
          </div>

        </MuiThemeProvider>
      );
    } else {
      return (
        <MuiThemeProvider>
          <div className="App">
            <Logo />
            <Paper zDepth={2} className="InterestForm">
              <div>
                <ThankYou />
              </div>
            </Paper>
          </div>

        </MuiThemeProvider>
      );
    }
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js